import { useCollections } from "@/hooks/useCollections";
import CollectionCard from "./CollectionCard";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const CollectionsSection = () => {
  const { data: collections = [], isLoading } = useCollections(6); // 2 rows of 3 max

  // Lightweight loading state - just a placeholder div
  if (isLoading) {
    return <div className="min-h-[150px]" />;
  }

  if (collections.length === 0) {
    return null;
  }

  return (
    <section className="py-4 md:py-6 bg-background">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="flex justify-between items-end mb-5">
          <div>
            <span className="block text-xs font-semibold tracking-widest uppercase text-primary mb-1">
              Curado por TicoMarket
            </span>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl text-foreground leading-tight">
              Ideas para regalar
            </h2>
          </div>
          <Link
            to="/productos"
            className="hidden sm:inline-flex text-sm font-semibold text-foreground underline underline-offset-4 decoration-primary/60 hover:decoration-primary items-center gap-1 group"
          >
            Ver todo
            <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
          </Link>
        </div>

        {/* Collections Grid - More compact and dense */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {collections.map((collection, index) => (
            <CollectionCard 
              key={collection.id} 
              collection={collection} 
              variant="compact"
              eager={index < 3}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CollectionsSection;
